export default __webpack_public_path__ + "static/media/PngItem_2550683.ec7f64bd.png";